var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interiorContainer"},[_c('leftPublicTree',{attrs:{"type":"interior","updatePersonList":_vm.updatePersonList}}),_c('rightPublicTable',{ref:"rightPublicTable",attrs:{"type":"interior"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }